export const doctorRegisterActions = {
  REGISTER_DOCTOR: {
    REQUEST: 'doctor-register/register-doctor-request',
    SUCCESS: 'doctor-register/register-doctor-success',
    FAILURE: 'doctor-register/register-doctor-failure',
    RESET: 'doctor-register/register-doctor-reset'
  }
};
